export const AUTHENTICATION = {
    TOKEN_TYPE: "Bearer",
    ACCESS_TOKEN: "access_token",
    REFRESH_TOKEN: "refresh_token",
}